<template>
  <layout>
    <div slot="content">
      <i-card title="航班管理">
        <div slot="content">
          <div>
            <el-form :inline="true" size="small" style="text-align: right">
              <el-form-item>
                <el-select v-model="filter.product_name" placeholder="请选择产品名称" clearable>
                  <el-option
                    v-for="item in skuOptions.product_name"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getList">查找</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="cateList" :border="true">
            <el-table-column prop="sku_id" width="200" label="产品ID"></el-table-column>
            <el-table-column prop="title" label="票券名称" width="350"></el-table-column>
            <el-table-column prop="product_name" label="产品名称" width="100"></el-table-column>
            <el-table-column prop="start_time" width="100" label="航班时间"></el-table-column>
            <el-table-column prop="price" width="100" label="官方售价"></el-table-column>
            <el-table-column prop="type" width="80" label="票种 ID"></el-table-column>
            <el-table-column prop="updated_at" label="更新时间"></el-table-column>
            <el-table-column prop="updated_at" label="操作" width="100">
              <div slot-scope="scope">
                <el-button type="primary" size="mini" @click="showStock(scope.row)">查看库存</el-button>
              </div>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <el-pagination background :page-size="pageInfo.per_page" :current-page="pageInfo.current_page"
                           layout="prev, pager, next"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
      <!--库存列表-->

      <el-dialog title="库存列表" :visible.sync="showStockDialog">
        <div class="curr-sku">
          {{ currSku.sku_id }} / {{ currSku.title }} / {{ currSku.price }}元
        </div>
        <el-table :data="stockList" border v-loading="loadingStock">
          <el-table-column property="sale_date" label="销售日期"></el-table-column>
          <el-table-column property="stock" label="库存"></el-table-column>
          <el-table-column property="voyberth_id" label="外代班次ID" width="150"></el-table-column>
          <el-table-column property="product_name" label="航线名称"></el-table-column>
          <el-table-column property="ship_name" label="船名"></el-table-column>
          <el-table-column property="ship_owner" label="船东"></el-table-column>
          <el-table-column property="updated_at" label="更新时间" width="170"></el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "cate",
  data() {
    return {
      cateList: [],
      showStockDialog: false,
      loadingStock: false,
      stockList: [],
      currSku: {},
      filter: {
        product_name: '',
      },
      loading: false,
      pageInfo: {
        current_page: 1,
        total: 0,
        per_page: 20
      },
      skuOptions: []
    }
  },
  methods: {
    getList: function () {
      this.$http.request('nightShipList', {page: this.pageInfo.current_page,filter:this.filter}).then(res => {
        this.cateList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
      });
    },
    showStock: function (sku) {
      this.showStockDialog = true;
      this.loadingStock = true;
      this.stockList = [];
      this.currSku = sku;
      this.$http.request('nightShipStock', {sku_id: sku.sku_id}).then(res => {
        this.stockList = res.data;
        this.loadingStock = false;
      });
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getList();
      window.scrollTo(0, 0)
    },
    getOptions: function () {
      this.$http.request('skuOptions').then(res => {
        this.skuOptions = res.data;
      })
    },
    reset: function () {
      for (let i in this.filter) {
        if (i !== 'goods_type') {
          this.filter[i] = '';
        }
      }
      this.getOrder();
    },
  },
  created: function () {
    this.getList();
    this.getOptions();
  }
}
</script>

<style scoped lang="less">
.curr-sku {
  padding-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/night_ship/sailing_list.vue